import '../scss/app.scss';

import { Offcanvas } from 'bootstrap';

const $ = jQuery;
window.galleryItems = [];

$(document).ready(function() {
	$('.header-navigation-wrapper .menu-item-has-children').hover(function() {
		$(this).children('.sub-menu').stop().slideToggle({
			duration: 200,
			start: function() {
				$(this).css({'display': 'flex'});
			},
		});
	});

	const menuTop = $('.header-navigation-wrapper').offset().top;
	let subMenuTop = 0;
	if ($('.submenu-container').length) {
		subMenuTop = $('.submenu-container').offset().top - $('.header-navigation-wrapper').height();
	}
	const stickyMenu = function() {
		let scrollTop = $(window).scrollTop() - $('#main-nav').height() + 18;
		const wpAdminBar = $('#wpadminbar').height() || 0;
		scrollTop = scrollTop + wpAdminBar;
		if (scrollTop > menuTop) {
			$('header.navigation .container').addClass('sticky');
			$('body').css('margin-top', $('.header-logo-wrapper').height() + $('.header-navigation-wrapper').height() + $('#main-nav').height() - 12 - 6);
			$('.header-navigation-wrapper').css('margin-top', wpAdminBar);
		}
		else {
			$('header.navigation .container').removeClass('sticky');
			$('body').css('margin-top', 0);
			$('.header-navigation-wrapper').css('margin-top', 0);
		}
	};
	const stickySubMenu = function() {
		if (subMenuTop == 0) {
			return;
		}
		let scrollTop = $(window).scrollTop();
		if ($('#wpadminbar').length) {
			scrollTop = scrollTop + $('#wpadminbar').height();
		}
		if (scrollTop > subMenuTop) {
			$('.submenu-container').addClass('sticky');
			$('.submenu-container').css('top', menuTop - $('.header-navigation-wrapper').height() + 10);
			$('.featured-image').attr('style', 'margin-bottom: ' + $('.submenu-container').height() + 'px !important');
		}
		else {
			$('.submenu-container').removeClass('sticky');
			$('.submenu-container').css('top', '0');
			$('.featured-image').css('margin-bottom', '0');
		}
	};
	stickyMenu();
	stickySubMenu();

	$(window).scroll(function() {
		stickyMenu();
		stickySubMenu();
	});

	function trd_submenu_scroll_to(el) {
		$('html, body').animate({
			scrollTop: $('#' + el).offset().top - 60
		}, 500);
	}

	$('.sticky-submenu a').click(function(e) {
		e.preventDefault();
		trd_submenu_scroll_to($(this).attr('href').split('#')[1]);
	});

	$('.sub-navigation a').click(function(e) {
		e.preventDefault();
		trd_submenu_scroll_to($(this).attr('href').split('#')[1]);
	});

	$('#deadlines-popup-open').click(function(e) {
		e.preventDefault();
		$('#deadlines-modal').modal({ fadeDuration: 50 });
	});

	if ($('.cart a.cart-contents').html() != '0') {
		$('#page-header .cart').css('display', 'inline-block');
	}
});

// Images Slider
$(document).ready(function() {
	$('.images-slider').slick({
		dots: false,
		arrows: true,
		infinite: true,
		speed: 300,
		slidesToShow: 2,
		variableWidth: true
    });

    $('.slider.images-slider').each(function() {
        $(this).find('.slick-slide a').featherlightGallery({
            previousIcon: '',
            nextIcon: '',
        });
    });
});

// Slider column
$(document).ready(function() {
    $('.slider-link').click(function(e) {
        e.preventDefault();
        $(this).lightGallery({
            download: false,
            dynamic: true,
            dynamicEl: window.galleryItems[$(this).data('set-id')],
            index: $(this).data('photo-id'),
        });
    });

	const colSliders = [];
	$('.col-slider').each(function() {
		const $s = $(this).slick({
			dots: true,
			arrows: true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			autoplay: false,
			swipe: false,
		});
		colSliders.push($s);
	});
});

// Gallery
$(document).ready(function() {
	$('.gallery').featherlightGallery({
		previousIcon: '<i class="fal fa-angle-left"></i>',
		nextIcon: '<i class="fal fa-angle-right"></i>',
	});
});

function bs_fix_vc_full_width_row() {
	var $fullrow = jQuery('[data-vc-full-width="true"]');
	jQuery.each($fullrow, function () {
		var $el = jQuery(this);
		var container_width = jQuery('body').width();
		var window_width = $el.width();
		if ($el.is('[data-vc-stretch-content="true"]')) {
			var divleft = (window_width - container_width) /2;
			var spacUnit = divleft;
			$el.css('left', spacUnit).css('right', '').css('width', container_width);
		}
	});
}

$(document).ready(function() {
	bs_fix_vc_full_width_row();
});
